import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isNewProduct(createdAt?: string | null, days: number = 30): boolean {
  if (!createdAt) return false;
  const created = new Date(createdAt);
  if (isNaN(created.getTime())) return false;
  const threshold = Date.now() - days * 24 * 60 * 60 * 1000;
  return created.getTime() >= threshold;
}
